import { Chess } from 'chess.js'
import { BehaviorSubject } from 'rxjs'
import { map } from 'rxjs/operators'
import { auth } from '../components/Login/firebase-config'
import { fromRef } from 'rxfire/firestore'
import { db } from '../components/Login/firebase-config'
import { collection, getDocs, where, query, doc, setDoc, updateDoc, arrayUnion, getDoc } from 'firebase/firestore';
import {timeoutt} from './GameApp'

let gameRef
let member
export let pgn = '';
export let gametime=0;
export const chess = new Chess()
export let updatedData
export let gameSubject
let depth=10
let skillLevel=20
let randomness=0
let playerSide='w'
let stockfish = new Worker("/stockfish-18-lite-single.js");


function configureStockfish() {
    stockfish.postMessage('uci');
    stockfish.postMessage(`setoption name Skill Level value ${skillLevel}`);
    stockfish.postMessage('isready');
}

function makeRandomMove() {
    const moves = chess.moves({ verbose: true });
    if (moves.length === 0) return;
    const pick = moves[Math.floor(Math.random() * moves.length)];
    try {
        chess.move(pick);
        updateGame();
    } catch (e) {
        console.warn('Random move rejected:', pick, e);
    }
}

function getStockfishMove(fen) {
    if (randomness > 0 && Math.random() < randomness) {
        setTimeout(() => makeRandomMove(), 200 + Math.random() * 400);
        return;
    }

    stockfish.postMessage('position fen ' + fen);
    stockfish.postMessage(`go depth ${depth}`); 
    stockfish.onmessage = function(event) {
        const eventData = event.data;
        if (eventData.startsWith("bestmove")) {
            const bestMoveRegex = /^bestmove\s(\w{2})(\w{2})(\w?)/;
            const match = bestMoveRegex.exec(eventData);
            if (match && match.length >= 3) {
                const fromSquare = match[1];
                const toSquare = match[2];
                const promotion = match[3] || undefined;
                const moveObj = { from: fromSquare, to: toSquare };
                if (promotion) moveObj.promotion = promotion;
                try {
                    chess.move(moveObj)
                    updateGame()
                } catch (e) {
                    console.warn('Stockfish move rejected:', moveObj, e);
                }
            }
        }
    };
}
export async function initGame(gameRefFb, localOptions) {   
    chess.reset()
    const { currentUser } = auth

    if (localOptions && localOptions.level) {
        depth = localOptions.level.depth;
        skillLevel = localOptions.level.skill;
        randomness = localOptions.level.randomness || 0;
        playerSide = localOptions.side || 'w';
    } else {
        depth = 10;
        skillLevel = 20;
        randomness = 0;
        playerSide = 'w';
    }

    if (gameRefFb) {
        gameRef = gameRefFb
        const docRef = collection(db, 'games');
        const gameQuery = query(docRef, where('game.gameId', '==', gameRefFb.id));
        const snapshot = await getDocs(gameQuery);
        let initialGame = null;
        snapshot.forEach(doc => {
            initialGame = doc.data();
        });

        if (!initialGame || !initialGame.game) {
            return 'notfound'
        }
        const creator = initialGame.game.members.find(m => m.creator === true)
        const usersCollectionRef = collection(db, 'backenddata');
        const currentUser = auth.currentUser;        
      const currentUserDocRef = doc(usersCollectionRef, currentUser.uid);
      let currentUserDocSnapshot = await getDoc(currentUserDocRef);   
      const username = currentUserDocSnapshot.exists()
        ? currentUserDocSnapshot.data().username
        : (auth.currentUser?.displayName || 'Guest');
        if (initialGame.game.status === 'waiting' && creator.uid !== currentUser.uid) {
            const currUser = {
                uid: currentUser.uid,
                name: username,
                piece: creator.piece === 'w' ? 'b' : 'w',
                time: creator.time
            }
            gametime=creator.time
 const updatedMembers = [...initialGame.game.members, currUser]
 const game = {
    status: 'ready',
    members: updatedMembers,
    gameId: gameRefFb.id
}
            // Store both players' ratings at game start (skip for unrated link games)
            const category = creator.time < 180 ? 'bullet' : creator.time < 600 ? 'blitz' : 'rapid';
            let ratingFields = {};
            if (initialGame.isRated !== false) {
                const ratingKey = `${category}Rating`;
                const myRatingVal = currentUserDocSnapshot.exists() ? (currentUserDocSnapshot.data()?.[ratingKey] ?? 1200) : 1200;
                const creatorDocSnap = await getDoc(doc(db, 'backenddata', creator.uid));
                const creatorRatingVal = creatorDocSnap.exists() ? (creatorDocSnap.data()?.[ratingKey] ?? 1200) : 1200;
                const wRating = currUser.piece === 'w' ? myRatingVal : creatorRatingVal;
                const bRating = currUser.piece === 'b' ? myRatingVal : creatorRatingVal;
                ratingFields = { whiteRating: wRating, blackRating: bRating, category, isRated: true };
            }

 await updateDoc(doc(db, "games", game.gameId), {
    game:game,
    whiteTime: creator.time,
    blackTime: creator.time,
    turnStartedAt: Date.now(),
    ...ratingFields,
})


        } else if (!initialGame.game.members.map(m => m.uid).includes(currentUser.uid)) {
            return 'intruder'
        }
        chess.reset()
        gameSubject = fromRef(gameRefFb).pipe(
            map(gameDoc => {
                const game = gameDoc.data()
                const { pendingPromotion, gameData, whiteTime, blackTime, ...restOfGame } = game
                member = game.game.members.find(m => m.uid === currentUser.uid)
                const oponent = game.game.members.find(m => m.uid !== currentUser.uid)
                if (gameData) {
                    chess.load(gameData)
                }
                const isGameOver = (chess.isGameOver()||timeoutt)
                const gameInfo = {
                    board: chess.board(),
                    fen: chess.fen(),
                    pendingPromotion,
                    isGameOver,
                    position: member.piece,
                    member,
                    oponent,
                    whiteTime: whiteTime !== undefined ? whiteTime : null,
                    blackTime: blackTime !== undefined ? blackTime : null,
                    result: isGameOver ? getGameResult() : null,
                    ...restOfGame
                };
                        return gameInfo;
            })
        )
    
    } else {
        gameRef = null
        gameSubject = new BehaviorSubject()
        stockfish.terminate();
        stockfish = new Worker("/stockfish-18-lite-single.js");
        configureStockfish();
        updateGame()
        if (playerSide === 'b') {
            getStockfishMove(chess.fen())
        }
    }

}

export async function resetGame() {
    if (gameRef) {
        await updateGame(null, true)
        chess.reset()
    } else {
        chess.reset()
        updateGame()
        // When the player has black, the engine opens the game
        if (playerSide === 'b') {
            getStockfishMove(chess.fen())
        }
    }

}

export function handleMove(from, to) {

    const promotions = chess.moves({ verbose: true }).filter(m => m.promotion)
    let pendingPromotion
    if (promotions.some(p => `${p.from}:${p.to}` === `${from}:${to}`)) {
        pendingPromotion = { from, to, color: promotions[0].color }
        updateGame(pendingPromotion)
    }

    if (!pendingPromotion) {
        move(from, to)
    }
}


export function move(from, to, promotion) {
    let tempMove = { from, to }
    if (promotion) {
        tempMove.promotion = promotion
    }
    if (gameRef) {
        if (member.piece === chess.turn()) {
            try {
                const legalMove = chess.move(tempMove)
                if (legalMove) {
                    updateGame(null, false, legalMove.san)
                }
            } catch (e) { return; }
        }
    } else {
        if (chess.turn() !== playerSide) return;
        try {
            const legalMove = chess.move(tempMove)
            if (legalMove) {
                updateGame()
                if (!chess.isGameOver()) {
                    getStockfishMove(chess.fen())
                }
            }
        } catch (e) { return; }
    }

}

async function updateGame(pendingPromotion, reset, newMoveSan) {
    const isGameOver = (chess.isGameOver()||timeoutt)

    if (gameRef) {
        const docRef = collection(db, 'games');
        const gameQuery = query(docRef, where('game.gameId', '==', gameRef.id));
        const querySnapshot = await getDocs(gameQuery);
        const existingData = querySnapshot.docs[0].data();

        const existingPgn = Array.isArray(existingData.pgn) ? existingData.pgn : [];
        const newPgn = newMoveSan ? [...existingPgn, newMoveSan] : existingPgn;
        updatedData = { gameData: chess.fen(), pendingPromotion: pendingPromotion || null, pgn: newPgn }

        if (newMoveSan) {
            // Server-authoritative clock: deduct elapsed wall-clock time from mover's budget, start next turn timer
            const now = Date.now();
            const prevTurnStart = existingData.turnStartedAt || now;
            const elapsed = (now - prevTurnStart) / 1000;
            // chess.move() was already called, so chess.turn() is the NEXT player; mover is the opposite
            const mover = chess.turn() === 'w' ? 'b' : 'w';
            const existingW = typeof existingData.whiteTime === 'number' ? existingData.whiteTime : 0;
            const existingB = typeof existingData.blackTime === 'number' ? existingData.blackTime : 0;
            const increment = typeof existingData.increment === 'number' ? existingData.increment : 0;
            updatedData.whiteTime = mover === 'w' ? Math.max(0, existingW - elapsed + increment) : existingW;
            updatedData.blackTime = mover === 'b' ? Math.max(0, existingB - elapsed + increment) : existingB;
            updatedData.turnStartedAt = now;
        }

        if (reset) {
            updatedData.status = 'over'
        }
        await updateDoc(doc(db, 'games', gameRef.id), updatedData);
    } else {
        const newGame = {
            board: chess.board(),
            fen: chess.fen(),
            pendingPromotion,
            isGameOver,
            position: chess.turn(),
            result: isGameOver ? getGameResult() : null
        }
        localStorage.setItem('savedGame', chess.fen())
        gameSubject.next(newGame)
    }


}
async function getGameResult() {
    if (gameRef) {
        // Backup: make sure this game is in the user's games list. GameApp.init()
        // already handles this on entry, but we do it again here in case the game
        // ends before that fire-and-forget write completes.
        const { currentUser } = auth;
        if (currentUser) {
            try {
                const userDocRef = doc(db, 'backenddata', currentUser.uid);
                const userDocSnapshot = await getDoc(userDocRef);
                const userData = userDocSnapshot.data() || {};
                const gamesArray = Array.isArray(userData.games) ? userData.games : [];
                if (!gamesArray.includes(gameRef.id)) {
                    await updateDoc(userDocRef, { games: [...gamesArray, gameRef.id] });
                }
            } catch (e) { /* non-fatal */ }
        }
    }
    if (chess.isCheckmate()) {
        const winner = chess.turn() === "w" ? 'BLACK' : 'WHITE'
        return `CHECKMATE - WINNER - ${winner}`
    } else if (chess.isDraw()) {
        let reason = '50 - MOVES - RULE'
        if (chess.isStalemate()) {
            reason = 'STALEMATE'
        } else if (chess.isThreefoldRepetition()) {
            reason = 'REPETITION'
        } else if (chess.isInsufficientMaterial()) {
            reason = "INSUFFICIENT MATERIAL"
        }
        return `DRAW - ${reason}`
    } else {
        return 'UNKNOWN REASON'
    }
}
